import type { StatusKey } from '@bbpos/ui';
import type { AccountStatus, InvoiceStatus, LedgerEntryType } from './types';

/** Maps AccountStatus → Badge variant from status-colors.ts */
export const ACCOUNT_STATUS_BADGE: Record<AccountStatus, { variant: StatusKey; label: string }> = {
  ACTIVE: { variant: 'active', label: 'Active' },
  OVERDUE: { variant: 'overdue', label: 'Overdue' },
  FROZEN: { variant: 'suspended', label: 'Frozen' },
  CLOSED: { variant: 'cancelled', label: 'Closed' },
};

/** Maps InvoiceStatus → Badge variant from status-colors.ts */
export const INVOICE_STATUS_BADGE: Record<InvoiceStatus, { variant: StatusKey; label: string }> = {
  OUTSTANDING: { variant: 'outstanding', label: 'Outstanding' },
  PARTIALLY_PAID: { variant: 'partiallyPaid', label: 'Partial' },
  PAID: { variant: 'paid', label: 'Paid' },
  WRITTEN_OFF: { variant: 'voided', label: 'Written Off' },
};

/** Maps LedgerEntryType → Badge variant */
export const LEDGER_TYPE_BADGE: Record<LedgerEntryType, { variant: StatusKey; label: string }> = {
  CREDIT_SALE: { variant: 'danger', label: 'Sale' },
  PAYMENT: { variant: 'success', label: 'Payment' },
  RETURN: { variant: 'success', label: 'Return' },
};
